// ChatResponsiveDesignLayout.js
'use strict';
import { connect } from 'react-redux';

import ChatResponsiveDesignLayout from '../page/ChatResponsiveDesignLayout.jsx';
import getOperationData from '../selector/getOperationData.js';
import { breakpoint } from '../style/variables.js';

const mapStateToProps = state => {
  const deviceWidth = getOperationData(state, ['device'], 'width');

  return {
    deviceHeight: getOperationData(state, ['device'], 'height'),
    isOnDesktop: deviceWidth > breakpoint.mobile,
  };
};

export default connect(mapStateToProps, null)(ChatResponsiveDesignLayout);
